<template>
  <article>
    <section class="xbed-sub-title">
      <span>代下单</span>
    </section>

    <section class="add-distance">
      <Form :model="createOrderForm" ref="createOrderForm" :rules="ruleValidate">
        <Row>
          <Col span="7">
            <FormItem prop="rentType" label="租房类型：" :label-width="120" style="margin-right: 40px">
              <Select v-model="createOrderForm.rentType" @on-change="changeRentType" transfer>
                <Option :value="1">短租</Option>
                <Option :value="2">长租</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem label="订单来源：" prop="sourceType" :label-width="120" style="margin-right: 40px">
              <Select v-model="createOrderForm.sourceType" @on-change="changeSourceType"
                :disabled="createOrderForm.rentType == 2">
                <Option v-for="source in sourceType" :key="source.id" :value="source.id">{{ source.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem v-if="showFields.payType" prop="payType" label="支付方式：" :label-width="120"
              style="margin-right: 40px">
              <Select v-model="createOrderForm.payType" transfer>
                <Option :value="7">银联（线下）</Option>
                <Option :value="8">支付宝（线下）</Option>
                <Option :value="9">微信（线下）</Option>
                <Option :value="10">现金（线下）</Option>
                <Option :value="11">其他（线下）</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem v-if="showFields.canOta" label="OTA单号：" prop="OTANo" :label-width="120"
              style="margin-right: 40px">
              <Input type="text" v-model="createOrderForm.OTANo"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="7">
            <FormItem prop="phone" label="预订人手机：" :label-width="120" style="margin-right: 40px">
              <Input type="text" v-model.trim="createOrderForm.phone" :maxlength="11"></Input>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="name" label="入住人姓名 (逗号隔开)" class="check-name" :label-width="120"
              style="margin-right: 40px">
              <Input type="text" v-model="createOrderForm.name"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="7">
            <FormItem label="入离时间：" prop="checkDate" :label-width="120" style="margin-right: 40px">
              <DatePicker v-model="createOrderForm.checkDate"
                @on-change="dateRange => { changeDate(dateRange, 'createOrderForm', 'checkDate') }" type="daterange"
                placeholder="选择日期" style="width: 100%" :options="dateOptions" :clearable="false" :editable="false">
              </DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="18">
            <FormItem label="房间：" :label-width="120">
              <Table stripe :columns="selectedRoomsColumn" :data="selectedRooms"></Table>
            </FormItem>
          </Col>
          <Col span="2" style="margin-left: 5.1%;">
            <FormItem>
              <Button type="primary" @click="openSelectingRoomsModal" :loading="chooseRoom">选择房间</Button>
            </FormItem>
            <FormItem>
              <Button @click="initSelectedRooms()">清空房间</Button>
            </FormItem>
          </Col>
        </Row>
        <Row v-if="currentSourceData.priceRelationState" class="showOta">
          <!-- <Button v-if="createOrderForm.rentType === 1" type="primary">获取OTA订单数据</Button> -->
          <a v-if="createOrderForm.rentType === 1" class="ivu-btn" @mouseenter="showChannel = true"
            @mouseleave="showChannel = false"
            :style="{ 'position': 'absolute', 'right': '57px', 'z-index': showChannel ? '1001' : 1 }">*渠道金额对应关系</a>
        </Row>
        <Row>
          <Col span="7">
            <FormItem prop="orderPrice" label="xbed原价：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.orderPrice" disabled
                ref='orderPrice'>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="discount" label="总优惠：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.discount"
                @input="calculateIn('discount')"
                :disabled="priceExpression.discount.type === 1 || createOrderForm.rentType === 2" ref='discount'>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="7" v-if="createOrderForm.rentType == 1">
            <FormItem prop="salePrice" label="渠道售价：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.salePrice"
                @input="calculateIn('salePrice')" :disabled="priceExpression.salePrice.type === 1" ref='salePrice'>
            </FormItem>
          </Col>
          <Col span="7" v-if="createOrderForm.rentType == 1">
            <FormItem prop="channelDiscount" label="渠道优惠：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.channelDiscount"
                @input="calculateIn('channelDiscount')" :disabled="priceExpression.channelDiscount.type === 1"
                ref='channelDiscount'>
            </FormItem>
          </Col>
          <Col span="7" v-if="createOrderForm.rentType == 2">
            <FormItem prop="bargainMoney" label="长租押金：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.bargainMoney"
                ref='bargainMoney' @input="calculateIn('bargainMoney')">
            </FormItem>
          </Col>
          <Col span="7" v-if="createOrderForm.rentType == 2">
            <FormItem v-if="createOrderForm.rentType == 2" prop="rentPrice" label="房费租金：" :label-width="120"
              style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.rentPrice" ref='rentPrice'
                @input="calculateIn('rentPrice')">
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="discountType" key="discountType" label="优惠类型：" :label-width="120"
              style="margin-right: 40px">
              <Select v-model="createOrderForm.discountType" placeholder="请选择优惠类型"
                :disabled="createOrderForm.price.discount === 0">
                <Option v-for="discount in discountType" :key="discount.id" :value="discount.id">{{ discount.name
                }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="7">
            <FormItem prop="realPrice" label="客人应付：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.realPrice"
                @input="calculateIn('realPrice')"
                :disabled="priceExpression.realPrice.type === 1 || createOrderForm.rentType === 2" ref='realPrice'>
            </FormItem>
          </Col>
          <!-- <Col span="7">
            <FormItem prop="userPay" label="客人实付：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.userPay" @input="calculateIn('userPay')" :disabled="priceExpression.userPay.type === 1 || createOrderForm.rentType === 2" ref='userPay'>
            </FormItem>
          </Col> -->
          <Col span="7">
            <FormItem prop="channelCommission" key="channelCommission" label="OTA佣金：" :label-width="120"
              style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.channelCommission"
                @input="calculateIn('channelCommission')" :disabled="priceExpression.channelCommission.type === 1"
                ref='channelCommission'>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="invoicePrice" label="发票金额：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.invoicePrice"
                @input="calculateIn('invoicePrice')"
                :disabled="priceExpression.invoicePrice.type === 1 || createOrderForm.rentType === 2" ref='invoicePrice'>
            </FormItem>
          </Col>
        </Row>
        <!-- <Row v-if="createOrderForm.rentType == 1">
          <Col span="7">
            <FormItem prop="otherChannelExpenses" label="渠道活动费：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.otherChannelExpenses" @input="calculateIn('otherChannelExpenses')" :disabled="priceExpression.otherChannelExpenses.type === 1" ref='otherChannelExpenses'>
            </FormItem>
          </Col>
        </Row> -->
        <Row>
          <Col span="7" v-if="createOrderForm.rentType == 1">
            <FormItem prop="receivedPrice" label="xbed实收：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="createOrderForm.price.receivedPrice"
                @input="calculateIn('receivedPrice')" :disabled="priceExpression.receivedPrice.type === 1"
                ref='receivedPrice'>
            </FormItem>
          </Col>
          <Col span="7" v-if="currentSourceData.invoceConfig === 2" style="margin-left: 452px">
            <FormItem label="" :label-width="120">
              <Checkbox v-model="createOrderForm.needInvoice">客人向xbed申请开发票</Checkbox>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col style="width: 85%;">
            <FormItem prop="remark" label="备注：" :label-width="120">
              <Input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" @on-change="handleChange"
                v-model="createOrderForm.remark" placeholder="必填"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </section>
    <section>
      <Button type="primary" @click="createOrder" :loading="btnLoading" size="large"
        style="width: 180px;margin-left:120px;">提交</Button>
    </section>

    <Modal v-model="selectingRoomsModalDisplay" ref="selectingRoomsModal" title="选择房间" ok-text="选好了" :width="1000"
      @on-ok="selectingRooms" @on-cancel="cancelSelectedRooms">
      <Form :model="selectingRoomsModalForm">
        <Row>
          <Col span="8">
            <FormItem prop="city" label="城市：" :label-width="80">
              <Select v-model="selectingRoomsModalForm.city" @on-change="changeCity" transfer filterable>
                <Option v-for="(city, index) in allCities" :key="index" :value="city">{{ city }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem prop="hotel" label="门店：" :label-width="80">
              <Select v-model="selectingRoomsModalForm.hotel" transfer filterable clearable ref="hotel">
                <Option v-for="hotel in allHotels" :key="hotel.chainId" :value="hotel.chainId">{{ hotel.chainName
                }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem prop="name" label="房型：" :label-width="80">
              <Select v-model="selectingRoomsModalForm.roomType" transfer clearable filterable>
                <Option v-for="roomType in allRoomTypes" :key="roomType.code" :value="roomType.cname">{{ roomType.cname
                }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem prop="roomNo" label="房号：" :label-width="80">
              <Input type="text" v-model="selectingRoomsModalForm.roomNo"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem prop="roomName" label="房名：" :label-width="80">
              <Input type="text" v-model="selectingRoomsModalForm.roomName"></Input>
            </FormItem>
          </Col>
          <Col span="6" offset="1">
            <FormItem>
              <Button type="primary" @click="queryRoomListWithKeyword">查找</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table stripe ref="modalSelection" :loading="roomList.loading" height="450" :columns="roomListColumn"
        :data="roomList.displayData"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="roomList.count" :current="roomList.page" :page-size="roomList.pageSize"
          @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
      <Row>
        <Col>{{ `已选择${modalSelectedRooms.length}房` }}</Col>
      </Row>

      <template #footer>
        <Button @click="selectingRoomsModalDisplay = false">取消</Button>
        <Button type="primary" @click="selectingRooms">选好了</Button>
      </template>
    </Modal>
    <!-- 渠道金额对应关系弹窗 -->
    <Row v-if="showChannel" class="ivu-modal-wrap">
      <div class="ivu-modal">
        <div class="ivu-modal-content">
          <div class="ivu-modal-header">
            <div class="ivu-modal-header-inner">渠道金额对应关系</div>
          </div>
          <div class="ivu-modal-body">
            <Row class="channel-row">
              <Col span="11" class="col"><em class="txt">渠道售价 = </em><span
                  :class="priceRelationDetail.salePrice ? '' : 'red'">{{ priceRelationDetail.salePrice ||
                    channelText }}</span></Col>
              <Col span="11" class="col"><em class="txt">渠道优惠 = </em><span
                  :class="priceRelationDetail.channelDiscount ? '' : 'red'">{{ priceRelationDetail.channelDiscount ||
                    channelText }}</span></Col>
            </Row>
            <Row class="channel-row">
              <Col span="11" class="col"><em class="txt">OTA佣金 = </em><span
                  :class="priceRelationDetail.channelCommission ? '' : 'red'">{{ priceRelationDetail.channelCommission ||
                    channelText }}</span></Col>
              <Col span="11" class="col"><em class="txt">发票金额 = </em><span
                  :class="priceRelationDetail.invoicePrice ? '' : 'red'">{{ priceRelationDetail.invoicePrice ||
                    channelText }}</span></Col>
            </Row>
            <Row class="channel-row">
              <Col span="11" class="col"><em class="txt">客人应付 = </em><span
                  :class="priceRelationDetail.userRealPay ? '' : 'red'">{{ priceRelationDetail.userRealPay ||
                    channelText }}</span></Col>
              <Col span="11" class="col"><em class="txt" style="min-width:85px;">xbed实收 = </em><span
                  :class="priceRelationDetail.receivedPrice ? '' : 'red'">{{ priceRelationDetail.receivedPrice ||
                    channelText }}</span></Col>
            </Row>
          </div>
        </div>
      </div>
    </Row>
  </article>
</template>

<script>
import MIXINS from '@/mixins'
import Moment from "moment"
import Utils from "../../utils";
import { contactPhoneRegExp } from "../../utils/regular"
import API from "../../api";
export default {
  mixins: [MIXINS.COMMON_SENSE],
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.userid = Utils.findFromLocalStorage("vue-userid");
    this.env = Utils.findFromLocalStorage("env", "dev");

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env),
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'group': 'dev' // 本地请求才需要加该参数
    }
  },
  async mounted() {

    this.$Notice.config({
      top: 200
    });

    this.hotspotPowerIds = (await API.omsAPI[this.env].php.getHotSpotIds()).data.toString();
    this.initDiscountType();
    this.initSourceType();
    this.changeCity('');

    const self = this

    // 设置是否当前页面的监听
    document.addEventListener('paste', (event) => {
      const content = event.clipboardData.getData('text/plain')
      console.log("contemtSsss16", decodeURI(encodeURI(content)))
      const contentStr = decodeURI(encodeURI(content)).replace(/；/g, "@@@").replace(/\s/g, '')
      console.log("contemtS", contentStr)
      if (/@@@预约单号[0-9a-zA-Z]/.exec(contentStr)) {
        const orderNo = /@@@预约单号[0-9a-zA-Z]+/.exec(contentStr)[0].replace('@@@预约单号', '')
        console.log("@@@", orderNo)
        self.createOrderForm.OTANo = orderNo
      }else if (/0?订单号.*/.exec(content)) {
        const orderNo = /[0-9a-zA-Z]+/.exec(/0?订单号.*/.exec(content)[0].replace(/\s+/g, ""))[0];
        self.createOrderForm.OTANo = orderNo
      } else if (/0?已接单.*/.exec(content)) {
        const orderNo = /[0-9a-zA-Z]+/.exec(/0?已接单.*/.exec(content)[0].replace(/\s+/g, ""))[0];
        self.createOrderForm.OTANo = orderNo
      }else {
        // 同程旅行特殊处理
        if(this.createOrderForm.sourceType === 15){
          const contentArr = content.split('\n')
          if(/H[0-9a-zA-Z]+/.exec(content)) {
            const orderNo = /H[0-9a-zA-Z]+/.exec(content)[0].replace(/ |" "|\t/g, "")
            this.createOrderForm.OTANo = orderNo
          }
          if (/[0-9]{4}-[0-9]{2}-[0-9]{2}至[0-9]{4}-[0-9]{2}-[0-9]{2}/.exec(content)) {
            const date = /[0-9]{4}-[0-9]{2}-[0-9]{2}至[0-9]{4}-[0-9]{2}-[0-9]{2}/.exec(content)[0].split('至')
            const startDate = date[0]//入住
            const endDate = date[1]//离开
            if(startDate >= this.createOrderForm.checkDate[0]){
              self.createOrderForm.checkDate = [startDate, endDate]
            }
          }
          this.createOrderForm.phone = "18925023157"
          this.createOrderForm.name = contentArr[2]
        }
        return
      }

      // 获取手机
      if (/@@@1[3456789][0-9]{9}/.exec(contentStr)) {
        const phone = /@@@1[3456789][0-9]{9}/.exec(contentStr)[0].replace('@@@', '')
        console.log("@@@", phone)
        self.createOrderForm.phone = phone
      }else if (/0?1[3456789][0-9]{9}/.exec(content)) {
        const phone = /0?1[3456789][0-9]{9}/.exec(content)[0]
        self.createOrderForm.phone = phone
      } else {
        self.createOrderForm.phone = '18925023157';
      }

      if (/晚@@@.{2,4}，/.exec(contentStr)) {
        const name = /晚@@@.{2,4}，/.exec(contentStr)[0].replace(/，/g, '').replace('晚', '').replace('@@@', '').replace('@', '').replace('@', '')
        console.log("@@@", name)
        self.createOrderForm.name = name
      }else if (/晚@@@.{2,4}/.exec(contentStr)) {
        const name = /晚@@@.{2,4}/.exec(contentStr)[0].replace('晚', '').replace('@@@', '').replace('@', '').replace('@', '')
        console.log("@@@", name)
        self.createOrderForm.name = name
      }else if (/0?入住人.*/.exec(content)) {
        // 获取入住人
        const name = /0?入住人.*/.exec(content)[0].replace(/\s+/g, "").replace('入住人', '')
        self.createOrderForm.name = name
      }

      if (/@@@[0-9]{4}-[0-9]{2}-[0-9]{2}入住/.exec(contentStr)) {
        const startDate = /@@@[0-9]{4}-[0-9]{2}-[0-9]{2}入住/.exec(contentStr)[0].replace(/@/g, '').replace('入住', '')
        const endDate = /入住[0-9]{4}-[0-9]{2}-[0-9]{2}离店/.exec(contentStr)[0].replace('入住', '').replace('离店', '')
        console.log("@@@", startDate, endDate, this.createOrderForm.checkDate[0])
        if(startDate >= this.createOrderForm.checkDate[0]){
          self.createOrderForm.checkDate = [startDate, endDate]
        }
      }else if (/0?入离日期.*/.exec(content)) {
        const date = /0?入离日期.*/.exec(content)[0].replace(/\s+/g, "").replace('入离日期', '').split('共')[0].split('至')
        const startDate = `${Moment().format('YYYY-')}${date[0]}`//入住
        const endDate = `${Moment().format('YYYY-')}${date[1]}`//离开
        self.createOrderForm.checkDate = [startDate, endDate]
      }

      //选择订单来源（暂时只有美团）
      // for (let index = 0; index < self.sourceType.length; index++) {
      //   const source = self.sourceType[index];
      //   if(/美团/.test(source.name)){
      //     self.createOrderForm.sourceType = source.id
      //     self.changeSourceType(source.id)
      //     break
      //   }
      // }

    })

  },
  data() {
    let defaultDate = [
      Moment().format("YYYY-MM-DD"),
      Moment().add(1, 'days').format("YYYY-MM-DD"),
    ];

    const validatePrice = {
      bargainMoney: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.bargainMoney)) && this.createOrderForm.rentType === 2) {
          callback(new Error('请输入金额'))
        } else {
          callback();
        }
      },
      rentPrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.rentPrice)) && this.createOrderForm.rentType === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      discount: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.discount)) && this.priceExpression.discount.type === 2 && this.createOrderForm.rentType === 1) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      invoicePrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.invoicePrice)) && this.priceExpression.invoicePrice.type === 2 && this.createOrderForm.rentType === 1) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      channelCommission: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.channelCommission)) && this.priceExpression.channelCommission.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      realPrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.realPrice)) && this.priceExpression.realPrice.type === 2 && this.createOrderForm.rentType === 1) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      // otherChannelExpenses: (rule, value, callback) => {
      //   if (isNaN(parseFloat(this.createOrderForm.price.otherChannelExpenses)) && this.priceExpression.otherChannelExpenses.type === 2) {
      //     callback(new Error('请输入金额'));
      //   } else {
      //     callback();
      //   }
      // },
      // userPay: (rule, value, callback) => {
      //   if (isNaN(parseFloat(this.createOrderForm.price.userPay)) && this.priceExpression.userPay.type === 2 && this.createOrderForm.rentType === 1) {
      //     callback(new Error('请输入金额'));
      //   } else {
      //     callback();
      //   }
      // },
      receivedPrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.receivedPrice)) && this.priceExpression.receivedPrice.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      salePrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.salePrice)) && this.priceExpression.salePrice.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      channelDiscount: (rule, value, callback) => {
        if (isNaN(parseFloat(this.createOrderForm.price.channelDiscount)) && this.priceExpression.channelDiscount.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      OTANo: (rule, value, callback) => {
        let strRegular = /^[a-zA-Z0-9+`~!@#$^*()-\\./?,<>;:'{}|]+$/
        if (this.createOrderForm.OTANo.trim() == "") {
          callback(new Error('OTA单号不能为空'));
        } if (!strRegular.test(this.createOrderForm.OTANo)) {
          callback(new Error('存在空格和不支持的符号，请修改'));
        } else {
          callback();
        }
      },
    }

    const validateDiscountType = (rule, value, callback) => {
      if (!this.createOrderForm.discountType && this.createOrderForm.price.discount !== 0) {
        callback(new Error('请选择优惠类型'))
      } else {
        callback();
      }
    }

    return {
      isPay: false,
      currentSourceData: {},  // 当前选择的订单来源相关数据
      priceRelationDetail: {}, // 渠道金额对应关系
      priceExpression: { // 订单来源的金额信息
        salePrice: {},
        channelDiscount: {},
        discount: {},
        realPrice: {},
        // userPay: {},
        channelCommission: {},
        // otherChannelExpenses: {},
        receivedPrice: {},
        invoicePrice: {}
      },
      chooseRoom: false, // 选择房间的loading
      channelText: '系统自动计算',
      discountType: [],
      discountTypeArr: [],
      sourceType: [],
      allCities: [],
      allHotels: [],
      allRoomTypes: [],
      delayTimer: null,
      dateOptions: {
        disabledDate(date) {
          let today = Moment().startOf('day').valueOf();
          let nowTime = Moment().valueOf();
          let oneDay = 86400000;
          if (nowTime < today + 21600000) {
            return date && date.valueOf() < (Date.now() - (oneDay * 2))
          } else {
            return date && date.valueOf() < Date.now() - oneDay;
          }
        }
      },
      // disabledFields: {
      //   invoicePrice: false,
      //   channelCommission: false,
      //   realPrice: false,
      //   otherChannelExpenses: false,
      //   userPay: false,
      //   receivedPrice: false
      // },
      showFields: {
        canOta: false,
        payType: false,
        needInvoice: false
      },
      createOrderForm: {
        rentType: 1,
        payType: 7,
        sourceType: 0,
        // paramList: [],
        OTANo: '',
        phone: '',
        name: '',
        checkDate: defaultDate,
        price: {
          bargainMoney: '',
          rentPrice: '',
          orderPrice: '',
          invoicePrice: '',
          discount: '',
          channelCommission: '',
          realPrice: '',
          // otherChannelExpenses: '',
          // userPay: 0,
          receivedPrice: '',
          salePrice: '',
          channelDiscount: '',
        },
        needInvoice: 0,
        discountType: '',
        remark: '',
      },
      preRoomPrice: '', // 房费原价，计算接口用的
      selectingRoomsModalDisplay: false,
      selectingRoomsModalForm: {
        city: "",
        hotel: "",
        roomType: "",
        roomNo: "",
        roomName: ""
      },
      selectedRoomsColumn: [
        {
          title: "房型",
          key: "roomType",
          align: "center",
          width: 190
        },
        {
          title: "房号",
          key: "roomNo",
          align: "center",
          width: 257
        },
        {
          title: "房名",
          key: "roomName",
          align: "center",
          width: 390
        },
        {
          title: "门店",
          key: "hotel",
          align: "center",
          width: 260
        }
      ],
      selectedRooms: [],
      roomListColumn: [
        {
          title: "操作",
          align: "center",
          width: 100,
          fixed: 'left',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  attrs: { disabled: params.row.loading },
                  props: {
                    type: params.row.isChecked ? "error" : "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.selectedChangeWithRow(params.row, params.index);
                    }
                  }
                },
                params.row.isChecked ? "取消选择" : "选择"
              )
            ]);
          }
        },
        {
          title: "房号",
          key: "custRoomNo",
          align: "center",
          fixed: 'left',
          width: 100
        },
        {
          title: "价格（元）",
          key: "price",
          align: "center",
          fixed: 'left',
          width: 200,
          render: (h, params) => {
            let price = (params.row.price / 100).toFixed(2);
            return h("div", {}, price);
          }
        },
        {
          title: "当前状态",
          key: "stat",
          align: "center",
          width: 150,
          render: (h, params) => {
            let stat = "";
            switch (params.row.stat) {
              case 1:
                stat = "干净房"
                break;
              case 2:
                stat = "脏房"
                break;
              case 3:
                stat = "已入住"
                break;
              case 4:
                stat = "停用"
                break;
              case 5:
                stat = "维修"
                break;
            }
            return h("div", {}, stat);
          }
        },

        {
          title: "房间展示名",
          key: "custRoomName",
          align: "center",
          width: 200
        },
        {
          title: "房型",
          key: "roomTypeName",
          align: "center",
          width: 150
        },
        {
          title: "所属门店",
          key: "chainName",
          align: "center",
          width: 200
        },
        {
          title: "所属楼宇",
          key: "buildingName",
          align: "center",
          width: 200
        }
      ],
      roomList: {
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: [],
        displayData: []
      },
      isSelect: true, // 价格计算完之后
      modalSelectedRooms: [],
      lsIndex: 0,
      btnLoading: false,
      ruleValidate: {
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          { type: "string", pattern: contactPhoneRegExp, message: "请填写正确的手机号码" }
        ],
        name: [
          { required: true, message: "姓名不能为空", trigger: "blur" }
        ],
        // OTANo: [
        //   { required: true, type:"string", message: "OTA单号不能为空", trigger: "blur" }
        // ],
        OTANo: [
          { validator: validatePrice.OTANo, trigger: 'blur' }
        ],
        discountType: [
          { validator: validateDiscountType, trigger: "change" }
        ],
        bargainMoney: [
          { validator: validatePrice.bargainMoney, type: "number", trigger: 'blur' }
        ],
        rentPrice: [
          { validator: validatePrice.rentPrice, type: "number", trigger: "blur" }
        ],
        discount: [
          { validator: validatePrice.discount, type: "number", trigger: 'blur' }
        ],
        salePrice: [
          { validator: validatePrice.salePrice, type: "number", trigger: 'blur' }
        ],
        channelDiscount: [
          { validator: validatePrice.channelDiscount, type: "number", trigger: 'blur' }
        ],
        invoicePrice: [
          { validator: validatePrice.invoicePrice, type: "number", trigger: 'blur' }
        ],
        channelCommission: [
          { validator: validatePrice.channelCommission, type: "number", trigger: 'blur' }
        ],
        realPrice: [
          { validator: validatePrice.realPrice, type: "number", trigger: 'blur' }
        ],
        // otherChannelExpenses: [
        //   { validator: validatePrice.otherChannelExpenses, type: "number", trigger: 'blur' }
        // ],
        // userPay: [
        //   { validator: validatePrice.userPay, type: "number", trigger: 'blur' }
        // ],
        receivedPrice: [
          { validator: validatePrice.receivedPrice, type: "number", trigger: 'blur' }
        ],
        remark: [
          { required: true, message: "请填写备注", trigger: "blur" },
          { type: "string", max: 500, message: "备注不能超过500字" }
        ],
      },
      showChannel: false   // 是否显示 渠道金额对应关系 弹窗
    };
  },
  methods: {
    // 优惠类型
    async initDiscountType() {
      this.discountType = this.discountTypeArr = (await API.omsAPI[this.env].php.queryDiscountType()).data.data;
    },
    // 订单来源
    async initSourceType() {
      let orderSourceResp = (await API.omsAPI[this.env].php.queryOrderSource()).data;
      if (orderSourceResp.retdata && orderSourceResp.retdata.length !== 0) {
        this.sourceType = orderSourceResp.retdata.filter(source => {
          if ((source.sourceType == 1 || source.sourceType == 2) && source.isShow == 1 && source.status == 1) {
            switch (source.sourceType) {
              case 1:
                source.name = `${source.name} | 自有渠道`
                break;
              case 2:
                source.name = `${source.name} | OTA渠道`
                break;
              // case 3:
              //   source.name = `${source.name} | 业主渠道`
              //   break;
            }
            return true;
          }
        });

        this.createOrderForm.sourceType = this.sourceType[0].id;
        this.changeSourceType(this.createOrderForm.sourceType)
        this.changeShowFields(this.sourceType[0]);
      }
      // this.changeDisabledFields(this.sourceType[0]);
    },
    initSelectedRooms() {
      this.selectedRooms = [];
      this.initFormPrice();
    },
    initFormPrice() {
      this.resetFormFields();
      let initParams = {
        price: {
          bargainMoney: '',
          rentPrice: '',
          orderPrice: '',
          invoicePrice: '',
          discount: '',
          channelCommission: '',
          realPrice: '',
          // otherChannelExpenses: '',
          // userPay: 0,
          receivedPrice: '',
          salePrice: '',
          channelDiscount: ''
        },
        discountType: '',
      };
      Object.assign(this.createOrderForm, initParams);
    },
    changeDate(dateRange, formName, datePicker) {
      if (!dateRange[0]) {
        this[formName][datePicker] = [];
      } else {
        if (dateRange[0] == dateRange[1]) {
          dateRange[1] = Moment(dateRange[1]).add(1, 'day')
        }
        let tranferDate = [
          Moment(dateRange[0]).format('YYYY-MM-DD'),
          Moment(dateRange[1]).format('YYYY-MM-DD')
        ]
        this[formName][datePicker] = tranferDate;
      }
      this.initSelectedRooms();
    },
    changeRentType(currTypeId) {
      this.createOrderForm.rentType = currTypeId
      this.initSelectedRooms();
      if (currTypeId == 2) {
        this.discountType = [
          {
            id: 3,
            isShow: 1,
            name: "长租优惠",
            type: 1
          }
        ]
        this.createOrderForm.sourceType = 4;
        this.changeSourceType(4)
        this.showFields.payType = true;
        this.showFields.canOta = false;
        this.createOrderForm.checkDate = [
          Moment().format("YYYY-MM-DD"),
          Moment().add(30, 'days').format("YYYY-MM-DD"),
        ];
      } else {
        this.discountType = this.discountTypeArr
        this.showFields.payType = false;
        this.createOrderForm.checkDate = [
          Moment().format("YYYY-MM-DD"),
          Moment().add(1, 'days').format("YYYY-MM-DD"),
        ];
      }
    },
    changeSourceType(currTypeId) {
      // 针对 “客服电话” 来源做特殊处理
      for (let i = 0; i < this.sourceType.length; i++) {
        if (this.sourceType[i].id == currTypeId) {
          this.createOrderForm.needInvoice = ['', true, false][this.sourceType[i].invoceConfig];
          // this.createOrderForm.paramList = currTypeId === 91 ? {'orderPrice': 1} : this.sourceType[i].paramList;
          this.changeShowFields(this.sourceType[i]);
          // this.changeDisabledFields(this.sourceType[i]);
          if (this.selectedRooms.length > 0) this.calculateIn('default')
          this.resetFormFields();
          return;
        }
      }
    },
    changeShowFields(sourceType) {
      this.currentSourceData = sourceType;
      this.priceRelationDetail = sourceType.priceRelationDetail && JSON.parse(sourceType.priceRelationDetail) || {}
      this.priceExpression = sourceType.expression && JSON.parse(sourceType.expression)
      this.showFields.canOta = sourceType.canOta;
      this.showFields.payType = sourceType.sourceType == 3;
      this.showFields.needInvoice = sourceType.invoceConfig == 2;
    },
    // changeDisabledFields(sourceType) {
    //   this.disabledFields.invoicePrice = !sourceType.paramList.invoicePrice;
    //   this.disabledFields.channelCommission = !sourceType.paramList.channelCommission;
    //   this.disabledFields.realPrice = !sourceType.paramList.realPrice;
    //   this.disabledFields.otherChannelExpenses = !sourceType.paramList.otherChannelExpenses;
    //   this.disabledFields.userPay = !sourceType.paramList.userPay;
    //   this.disabledFields.receivedPrice = !sourceType.paramList.receivedPrice;
    // },
    async openSelectingRoomsModal() {
      this.chooseRoom = true;
      if (this.allCities.length === 0) {
        let allCitiesResp = (await API.omsAPI[this.env].php.queryAllCities()).data.data;
        this.allCities = allCitiesResp;
      }

      if (this.allRoomTypes.length === 0) {
        let roomTypesResp = (await API.omsAPI[this.env].php.queryModeAndStyleAndType({ operTypeList: ['roomType'] })).data;
        this.allRoomTypes = roomTypesResp.retdata;
      }

      this.modalSelectedRooms = [...this.selectedRooms];
      this.selectingRoomsModalDisplay = true;
      this.chooseRoom = false;
    },
    async changeCity(city) {
      // this.$refs.hotel.clearSingleSelect()
      this.selectingRoomsModalForm.hotel = "";
      let params = { city };
      let allHotelsResp = (await API.omsAPI[this.env].php.queryChainByCity(params)).data;
      this.allHotels = allHotelsResp.data;
    },
    // 查询房间列表
    checkQueryParams() {
      if (this.selectingRoomsModalForm.city || this.selectingRoomsModalForm.hotel || this.selectingRoomsModalForm.roomType || this.selectingRoomsModalForm.roomNo || this.selectingRoomsModalForm.roomName) {
        return true;
      }
      this.$Notice.error({
        title: "查询失败",
        desc: "请至少输入一个参数"
      });
      return false;
    },
    queryRoomListWithKeyword() {
      if (!this.checkQueryParams()) {
        return;
      }
      this.queryRoomList()
    },
    async queryRoomList() {
      this.roomList.loading = true;
      let { roomList = [], totalElements = 0 } = (await this.sendRoomList(this.roomList, this.token, this.env)).data;
      this.roomList.data = roomList.map(room => {
        room.isChecked = false;
        room.loading = false
        return room;
      });
      this.roomList.page = 1;
      this.roomList.count = totalElements;
      this.roomList.loading = false;

      this.displayRoomList();
    },
    sendRoomList(roomList, token, env) {
      let params = {
        page: roomList.page,
        size: 99999999,
        beginDate: Moment(this.createOrderForm.checkDate[0]).format("YYYY-MM-DD"),
        endDate: Moment(this.createOrderForm.checkDate[1]).format("YYYY-MM-DD"),
        tag: this.createOrderForm.rentType == 1 ? 'cnameWay=租赁方式/短租' : 'cnameWay=租赁方式/长租',
        hotspotPowerIds: this.hotspotPowerIds,
      }
      this.selectingRoomsModalForm.city ? params.city = this.selectingRoomsModalForm.city : '';
      this.selectingRoomsModalForm.hotel ? params.chainId = this.selectingRoomsModalForm.hotel : '';
      this.selectingRoomsModalForm.roomType ? params.roomTypeName = this.selectingRoomsModalForm.roomType : '';
      this.selectingRoomsModalForm.roomNo ? params.custRoomNo = this.selectingRoomsModalForm.roomNo : '';
      this.selectingRoomsModalForm.roomName ? params.custRoomName = this.selectingRoomsModalForm.roomName : '';
      return API.omsAPI[env].order.queryAvailableRooms(params, token);
    },
    displayRoomList() {
      let startIndex = (this.roomList.page - 1) * this.roomList.pageSize;
      let endIndex = this.roomList.pageSize * this.roomList.page;

      //  重置展示数组
      this.roomList.displayData = [];

      let displayData = [];
      for (let i = startIndex; i < endIndex; i++) {
        if (!this.roomList.data[i]) break;
        displayData.push(this.roomList.data[i]);
      }
      this.roomList.displayData = displayData;

      this.$nextTick(() => {
        this.changeRowCheckedProps();
      });
    },
    changeRowCheckedProps() {
      let length = this.modalSelectedRooms.length;
      for (let i = 0; i < length; i++) {
        let roomId = this.modalSelectedRooms[i].roomId;
        for (let j = 0; j < this.roomList.displayData.length; j++) {
          let matchRoomId = this.roomList.displayData[j].roomId;
          if (roomId == matchRoomId) {
            this.roomList.displayData[j].isChecked = true;
          }
        }
      }
    },
    selectedChangeWithRow(currRow) {
      if (!currRow.isChecked) {
        let roomId = currRow.roomId
        let params = {
          beginDateTime: Moment(this.createOrderForm.checkDate[0]).format("YYYY-MM-DD"),
          endDateTime: Moment(this.createOrderForm.checkDate[1]).format("YYYY-MM-DD"),
          roomId
        }

        let roomsPriceResp = null, roomGuaranteeResp = null
        currRow.loading = true
        this.isSelect = false
        API.omsAPI[this.env].order.queryRoomsPrice(params, this.token).then((res) => {
          roomsPriceResp = res
          if (roomsPriceResp.status == false) {
            this.$Notice.error({
              title: "选择失败",
              desc: roomsPriceResp.msg
            });
            currRow.isChecked = false
            this.isSelect = true
            currRow.loading = false
            return;
          }
          API.omsAPI[this.env].order.queryRoomGuarantee(roomId, this.token).then((res) => {
            roomGuaranteeResp = res
            if (roomGuaranteeResp.status == false) {
              this.$Notice.error({
                title: "选择失败",
                desc: roomGuaranteeResp.msg
              });
              currRow.isChecked = false
              currRow.loading = false
              this.isSelect = true
              return;
            }
            let roomPrice = roomsPriceResp.data[currRow.roomId];
            let selectedRoom = {
              roomId: currRow.roomId,
              roomType: currRow.roomTypeName,
              roomNo: currRow.custRoomNo,
              roomName: currRow.custRoomName,
              hotel: currRow.chainName,
              price: roomPrice.price / 100,
              number: roomPrice.number,
              bargainMoney: (Object.keys(roomGuaranteeResp.data).length == 0 ? 0 : roomGuaranteeResp.data.guarantee) / 100,
              rentPrice: roomPrice.longPrice ? roomPrice.longPrice / 100 : 0
            };
            let bol = this.modalSelectedRooms.some(item => item.roomId === currRow.roomId)
            if (!bol)
              this.modalSelectedRooms.push(selectedRoom);
            currRow.isChecked = true
            currRow.loading = false
            this.isSelect = true
          });
        });
        // let roomGuaranteeResp = (await API.omsAPI[this.env].order.queryRoomGuarantee(roomId, this.token));
      } else {
        let delIndex = -1;
        for (let i = 0; i < this.modalSelectedRooms.length; i++) {
          let matchRoomId = this.modalSelectedRooms[i].roomId;
          if (currRow.roomId == matchRoomId) {
            delIndex = i;
            break;
          }
        }

        this.modalSelectedRooms.splice(delIndex, 1);
        this.isSelect = true
        currRow.isChecked = false
      }
    },
    changePage(pageIndex) {
      this.roomList.page = pageIndex;
      this.displayRoomList();
    },
    changePageSize(pageSize) {
      this.roomList.page = 1;
      this.roomList.pageSize = pageSize;
      this.displayRoomList();
    },
    selectingRooms() {
      if (!this.isSelect) {
        this.$Notice.warning({
          title: "正在获取房间信息，请稍后",
        });
        return
      }
      this.selectedRooms = this.modalSelectedRooms;
      this.setOrderPriceAndBarginMoney(this.modalSelectedRooms);
      this.resetSelectingRoomsModalForm();
      this.resetRoomList();
      this.resetFormFields();
      this.selectingRoomsModalDisplay = false
    },
    setOrderPriceAndBarginMoney(selectedRooms) {
      let bargainMoney = 0;
      let orderPrice = 0;
      let rentPrice = 0;
      for (let i = 0; i < selectedRooms.length; i++) {
        bargainMoney += +selectedRooms[i].bargainMoney;
        orderPrice += +selectedRooms[i].price;
        rentPrice += +selectedRooms[i].rentPrice;
      }
      if (this.createOrderForm.rentType === 1) {
        this.createOrderForm.price.bargainMoney = 0;
        this.createOrderForm.price.rentPrice = 0;
        // this.createOrderForm.price.orderPrice = orderPrice;
      } else if (this.createOrderForm.rentType === 2) {
        this.createOrderForm.price.bargainMoney = bargainMoney;
        this.createOrderForm.price.rentPrice = rentPrice;
        // this.createOrderForm.price.orderPrice = Number((orderPrice + bargainMoney).toFixed(2))
      }
      this.createOrderForm.price.orderPrice = orderPrice;
      this.preRoomPrice = orderPrice;
      this.calculateIn('default') // 重新计算价格
    },
    cancelSelectedRooms() {
      this.modalSelectedRooms = [];
      this.resetSelectingRoomsModalForm();
      this.resetRoomList();
    },
    // 限制输入框number长度限制
    limitLength(key) {
      if (this.$refs[key] && this.$refs[key].value.length > 8) {
        this.$refs[key].value = this.$refs[key].value.slice(0, 8)
        this.createOrderForm.price[key] = this.$refs[key].value
      }
    },
    // 计算价格
    async calculatePriceAli(params) {
      let resp = (await API.omsAPI[this.env].clientServer.calculatePriceAli(
        params,
        this.protHeaders
      )).data;

      if (resp.retCode) {

        // 错误警告
        this.$Notice.error({
          title: "获取计算价格数据失败",
          desc: resp.retsmsg
        });
        return
      }
      Object.assign(this.createOrderForm.price, resp)
      if (resp.discount === 0) this.createOrderForm.discountType = ''
      this.isPay = false
    },
    calculateIn(key) {
      this.limitLength(key)  // 限制输入框的字数长度
      clearTimeout(this.delayTimer);
      let params = {
        sourceId: this.createOrderForm.rentType === 2 ? -1 : this.currentSourceData.id
      }
      if (this.selectedRooms.length === 0) return;
      params['orderPrice'] = Number((this.preRoomPrice).toFixed(2)) || 0
      if (this.createOrderForm.rentType === 1 && key !== 'default') {
        for (let i in this.priceExpression) {
          if (this.priceExpression[i].type === 2) {
            params[i] = Number((this.createOrderForm.price[i]).toFixed(2)) || 0;
          }
        }
      }
      if (this.createOrderForm.rentType === 2 || key === 'bargainMoney' || key === 'rentPrice') {
        params['bargainMoney'] = Number((this.createOrderForm.price.bargainMoney).toFixed(2)) || 0;
        params['rentPrice'] = Number((this.createOrderForm.price.rentPrice).toFixed(2)) || 0;
      }
      this.isPay = true
      this.delayTimer = setTimeout(() => {
        this.calculatePriceAli(params)
      }, 1000)
    },
    createOrder() {
      let validResult = true;
      this.$refs["createOrderForm"].validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        return;
      }
      if (this.selectedRooms.length == 0) {
        this.$Notice.error({
          title: "请选择房间"
        });
        return;
      }
      if (this.isPay) {
        this.$Notice.error({
          title: "正在计算金额请稍后"
        });
        return;
      }
      this.createOrderCommonSense(this.createOrderForm.price.orderPrice, this.createOrderForm.price.realPrice, (validator) => {
        validator && this.prePlaceOrder()
      })
    },
    async prePlaceOrder() {
      this.btnLoading = true;
      let roomIds = this.getRoomIds();
      let resp = (await this.sendPlaceOrder(
        this.createOrderForm,
        roomIds,
        this.userid,
        this.token,
        this.env
      )).data;
      this.btnLoading = false;
      if (resp.retCode) {
        // 错误警告
        this.$Notice.error({
          title: "下单失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "下单成功"
        });

        // TODO:下单成功后需清空
        this.initSelectedRooms();
        this.clearAllData();

        window.open(`#/Order/Reserve/newOrderDetailView?orderNo=${resp}`);
      }
    },

    clearAllData() {
      Object.assign(this.createOrderForm, {
        // rentType: 1,
        payType: 7,
        sourceType: this.currentSourceData.id,
        OTANo: '',
        phone: '',
        name: '',
        checkDate: [
          Moment().format("YYYY-MM-DD"),
          Moment().add(1, 'days').format("YYYY-MM-DD"),
        ],
        price: {
          bargainMoney: '',
          rentPrice: '',
          orderPrice: '',
          invoicePrice: '',
          discount: '',
          channelCommission: '',
          realPrice: '',
          // otherChannelExpenses: '',
          // userPay: 0,
          receivedPrice: '',
          salePrice: '',
          channelDiscount: ''
        },
        needInvoice: this.currentSourceData.invoceConfig === 2 ? false : true,
        discountType: '',
        remark: '',
      })

      this.preRoomPrice = ''
      if (this.createOrderForm.rentType == 2) this.changeRentType(1)
    },

    sendPlaceOrder(createOrderForm, roomIds, userId, token, env) {
      let params = {
        activityId: -1,
        rentType: createOrderForm.rentType,
        payType: this.showFields.payType ? createOrderForm.payType : '',
        bargainMoney: this.accMulPrice(createOrderForm.price.bargainMoney),
        rentPrice: this.accMulPrice(createOrderForm.price.rentPrice),
        beginDate: Moment(createOrderForm.checkDate[0]).format("YYYY-MM-DD"),
        endDate: Moment(createOrderForm.checkDate[1]).format("YYYY-MM-DD"),
        channelCommission: this.accMulPrice(createOrderForm.price.channelCommission),
        discount: this.accMulPrice(createOrderForm.price.discount),
        discountId: createOrderForm.discountType,
        invoicePrice: this.accMulPrice(createOrderForm.price.invoicePrice),
        name: createOrderForm.name,
        needInvoice: createOrderForm.needInvoice || this.currentSourceData.invoceConfig === 1 ? 1 : 0,
        orderPrice: this.accMulPrice(this.preRoomPrice),
        // otherChannelExpenses: this.accMulPrice(createOrderForm.price.otherChannelExpenses),
        otherNo: createOrderForm.OTANo,
        phone: createOrderForm.phone,
        realPrice: this.accMulPrice(createOrderForm.price.realPrice),
        receivedPrice: this.accMulPrice(createOrderForm.price.receivedPrice),
        remark: createOrderForm.remark,
        roomIds,
        source: createOrderForm.sourceType,
        // userPay: 0, // this.accMulPrice(createOrderForm.price.userPay),
        operator: this.username,
        userId: this.userId,
        salePrice: this.accMulPrice(createOrderForm.price.salePrice),
        channelDiscount: this.accMulPrice(createOrderForm.price.channelDiscount)
      }
      params = Utils.deleteEmptyProperty(params);
      return API.omsAPI[env].order.placeOrder(params, token);
    },
    accMulPrice(price) {
      return +Number.parseFloat(price * 100).toFixed(0);
    },
    accDivPrice(price) {
      return +Number.parseFloat(price / 100).toFixed(2);
    },
    getRoomIds() {
      let roomIds = [];
      for (let i = 0; i < this.selectedRooms.length; i++) {
        let roomId = this.selectedRooms[i].roomId;
        roomIds.push(roomId);
      }
      roomIds = new Set(roomIds);
      return Array.from(roomIds).toString();
    },
    resetFormFields() {
      let fields = Object.assign({}, this.createOrderForm);
      this.$refs.createOrderForm.resetFields();
      this.createOrderForm = fields;
    },
    resetRoomList() {
      this.roomList = {
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      };
    },
    resetSelectingRoomsModalForm() {
      this.selectingRoomsModalForm = {
        city: "",
        hotel: "",
        roomType: "",
        roomNo: "",
        roomName: ""
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-distance {
  margin-top: 20px;
}

.inputType {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #dbdbdb;
  padding: 0 5px;
}

.inputType[disabled] {
  background-color: #ccc;
}

.showOta {
  width: 81.17%;
  height: 32px;
  margin-left: 120px;
  margin-bottom: 24px;
}

.channel-row {
  width: 92%;
  margin: 0 auto 10px;
  font-size: 14px;
  line-height: 44px;

  .col {
    display: flex;

    &:nth-child(odd) {
      margin-right: 42px;
    }

    .txt {
      font-style: normal;
      min-width: 78px;
    }

    span {
      color: #339900;
      font-weight: bold;
      line-height: 25px;
      margin-top: 10px;

      &.red {
        color: #ff0000;
      }
    }
  }
}

.ivu-modal-wrap {
  pointer-events: none;
  width: 600px;
  overflow: initial;
  top: 28%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/create-order.vue